export const permanentDeletionLabels = {
  successMessage: "Drip has been successfully deleted.",
  content: "After this action, all the progress in this drip will be lost.",
};

export const inactivateLabels = {
  successMessage: "Drip has been successfully ended.",
  content: "After this action, your drip will be permanently inactivated.",
};
